import Vue from 'vue';
import {
  findIndex as _findIndex,
} from 'lodash-es';

const state = {
  events: [],
  selectedEvent: {},
  addToCalendarDialog: false,
  addAllEvents: false,
  showEventFormDialog: false,
  showEventAttendeesDialog: false,
  attendees: [],
  showEventPasswordVerifyDialog: false,
  companies: [],
  isCompaniesInitialize: false,
  dealers: [],
};

const getters = {
  getEvents: st => st.states,
};

const mutations = {
  setEvents: (st, data) => {
    st.events = data;
  },
  setIsCompaniesInitialize(st,data){
    st.isCompaniesInitialize = data
  },
  addEvent: (st, data) => {
    st.events.push(data);
  },
  updateEvent: (st, payload) => {
    const index = _findIndex(st.events, { id: payload.id });

    Vue.set(st.events, index, payload);
  },
  setAddToCalendarDialog: (st, payload) => {
    st.addToCalendarDialog = payload;
  },
  setSelectedEvent: (st, payload) => {
    st.selectedEvent = payload;
  },
  setAddAllEventsState: (st, payload) => {
    st.addAllEvents = payload;
  },
  setEventFormDialogState: (st, payload) => {
    st.showEventFormDialog = payload;
  },
  setEventAttendeesDialogState: (st, payload) => {
    st.showEventAttendeesDialog = payload;
  },
  setAttendeesState: (st, payload) => {
    st.attendees = payload;
  },
  setEventPasswordVerifyDialogState: (st, payload) => {
    st.showEventPasswordVerifyDialog = payload;
  },
  setCompaniesState: (st, payload) => {
    st.companies = payload;
  },
  setDealersState: (st, payload) => {
    st.dealers = payload;
  }
};


const actions = {
  setIsCompaniesInitialize({commit},payload){
    commit('setIsCompaniesInitialize',payload)
  },
  setAddAllEventsState({ commit }, payload) {
    commit('setAddAllEventsState', payload);
  },
  setSelectedEvent({ commit }, payload) {
    commit('setSelectedEvent', payload);
  },
  setAddToCalendarDialog({ commit }, payload) {
    commit('setAddToCalendarDialog', payload);
  },
  getEvents({ commit }, payload) {
    return this._vm.axios
      .get(`/events?year=${payload.year}&month=${payload.month}`)
      .then(({ data }) => {
        commit('setEvents', data);
      });
  },
  // eslint-disable-next-line no-unused-vars
  addEvent({ commit }, payload) {
    commit('addEvent', payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateEvent({ commit }, payload) {
    commit('updateEvent', payload);
  },
  setEventFormDialogState({ commit }, payload) {
    commit('setEventFormDialogState', payload);
  },
  setEventAttendeesDialogState({ commit }, payload) {
    commit('setEventAttendeesDialogState', payload);
  },
  setAttendeesState({ commit }, payload) {
    commit('setAttendeesState', payload);
  },
  setEventPasswordVerifyDialogState({ commit }, payload) {
    commit('setEventPasswordVerifyDialogState', payload);
  },
  setDealersState({ commit }, payload) {
    commit('setDealersState', payload);
  },
  setCompaniesState({ commit }, payload) {
    commit('setCompaniesState', payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
